import { render, staticRenderFns } from "./PolicyItem.vue?vue&type=template&id=2ee8df9e&scoped=true&"
import script from "./PolicyItem.vue?vue&type=script&lang=ts&"
export * from "./PolicyItem.vue?vue&type=script&lang=ts&"
import style0 from "./PolicyItem.vue?vue&type=style&index=0&id=2ee8df9e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee8df9e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VChip,VIcon})
